<template>
    <planner-overlay style="position: relative; height: 100%; width: 100%">
        <planner-viewport />
    </planner-overlay>
</template>

<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import PlannerViewport from '@/planner/PlannerViewport.vue';
    import PlannerOverlay from '@/planner/PlannerOverlay.vue';
    import { usePlannerStore } from '@/planner/plannerStore';
    import { watchImmediate } from '@vueuse/core';
    import { useVersion } from '@/app/version';
    import { onMounted, onUnmounted } from 'vue';

    const route = useRoute();
    const plannerStore = usePlannerStore();

    const versionStore = useVersion();
    await versionStore.load();

    watchImmediate(
        () => route.params.id,
        () => plannerStore.loadCase(Number(route.params.id)),
    );

    onMounted(() => plannerStore.run());
    onUnmounted(() => plannerStore.stop());
</script>
